export default "__VITE_ASSET__DTI4v3n$__"